import React from 'react';

const Hero = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Hi! I'm Russell!</h1>
            <div className="underline"></div>
            <p className="subtitle">
              <em>Building simple, affordable business websites that help you get local customers <strong>since 2006</strong>.</em>
            </p>
            <button className="cta-button" onClick={scrollToContact}>
              Get in touch
            </button>
          </div>
          <div className="hero-image">
            <div className="profile-photo">
              <img 
                src="./images/russell-profile.jpg"
                alt="Russell Pope - Freelance Designer" 
              />
            </div>
          </div>
        </div>
      </div>
      <div className="wave-divider"></div>
    </section>
  );
};

export default Hero; 